import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { motion } from "framer-motion";

const brandNavy = "#344e66";

const itemVariants = {
  hidden: { opacity: 0, scale: 0.95 },
  visible: { opacity: 1, scale: 1, transition: { duration: 0.4 } },
};

const services = [
  "HR Software", "Online Store", "Inventory", "Home Care",
  "Medical", "Lab Management", "Fintech", "Learning & Development"
];

const Home = () => {
  return (
    <Container className="py-5">
      <motion.div initial="hidden" whileInView="visible" viewport={{ once: true }}>
        <Row className="g-3 justify-content-center">
          {services.map((service, index) => (
            <Col xs={6} md={3} key={index}>
              <motion.div variants={itemVariants}>
                <Card 
                  className="border-0 shadow-sm p-3 rounded-0 text-center h-100"
                  style={{ borderBottom: `3px solid ${brandNavy}` }}
                >
                  <Card.Body className="d-flex align-items-center justify-content-center">
                    <span className="fw-semibold small text-uppercase" style={{ color: brandNavy, letterSpacing: "0.05em" }}>
                      {service}
                    </span>
                  </Card.Body>
                </Card>
              </motion.div>
            </Col>
          ))}
        </Row>
      </motion.div>
    </Container>
  );
};

export default Home;